import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"
import axios from "axios"
import { API_OPERATIONS_URL } from "../constants"
import { checkIsFailure } from "../utils/utils"
import { RootState } from "../../store/store"
import { IOperationItem, OperationType } from "../interface"


async function fetchOperationsList(
  token: string | null,
  limit: number | undefined,
  operationType: OperationType | null,
) {
  const response = await axios(
    `${API_OPERATIONS_URL}?limit=${limit}&operationTypes=${operationType}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  )

  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка при получении списка операций")
  }

  return response.data.items
}

export const useGetRecentOperations = (
  limit: number | undefined,
  operationType: OperationType | null,
) => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<IOperationItem[]>({
    queryKey: ["recent-operations", token],
    queryFn: () => fetchOperationsList(token, limit, operationType),
    enabled: Boolean(token),
  })
}